import script from "./SelectSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectSearch.vue?vue&type=script&setup=true&lang=js"

import "./SelectSearch.vue?vue&type=style&index=0&id=52c0e388&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\unensedu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52c0e388"]])

export default __exports__